import * as zod from "zod/v4";
import {
  CampaignFilterConditionSchema,
  CampaignScheduleSchema,
  CampaignSchema,
  CampaignSlackDestinationSchema,
} from "./get-campaigns";

export const createCampaign = {
  name: "createCampaign" as const,
  input: zod.object({
    name: zod.string(),
    description: zod.string().optional(),
    filters: zod.array(CampaignFilterConditionSchema),
    filterLogic: zod.enum(["and", "or"]),
    schedule: CampaignScheduleSchema,
    messageStyle: zod.enum(["individual", "digest"]),
    destination: CampaignSlackDestinationSchema,
  }),
  output: zod.object({ campaign: CampaignSchema }),
};
